import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
    return (
        <div className="terms-container">
            <h1 className="terms-header">Terms and Conditions</h1>

            <p>
                Top Tier Benefits, Inc (TTB) specializes in the provision of distance-based pharmacy care and mail-order delivery of pharmacy medicine 
                from the contracted pharmacy located at 123 St. Anne’s Rd, in Winnipeg, Manitoba, Canada. The following terms and conditions apply to 
                all sales and delivery of pharmaceuticals between TTB, the contracted pharmacy, and you, the patient. By accepting delivery of the 
                products and services from TTB and the contracted pharmacy, you agree to be bound by and accept these terms and conditions of sale.
            </p>

            <h2>About You</h2>
            <p>
                By placing an order with TTB, you acknowledge that you are of the age of majority in the jurisdiction where you live, are entitled to make 
                your own medical decisions, are of sound mind, and understand and consent to these terms and conditions of sale without undue influence or 
                duress. You acknowledge that these terms of sale are readily accessible on a 24-hour basis on the TTB website (located at 
                <a href="https://www.toptierbenefits.com/termsandconditions" target="_blank" rel="noopener noreferrer"> www.toptierbenefits.com/termsandconditions</a>) 
                and that you have every opportunity to obtain independent legal advice with respect to them.
            </p>

            <h2>Prescription Required</h2>
            <p>
                You acknowledge that TTB will not accept any prescription medication order unless we receive a valid prescription from you. A prescription 
                must be issued by a licensed practitioner based upon and after the appropriate personal examinations as determined by your home jurisdiction’s 
                medical standards of practice.
            </p>

            <h2>Your Prescription</h2>
            <p>
                A qualified and licensed physician has lawfully prescribed the medications you have requested. You have attended, had a physical examination, 
                received a prescription from a duly licensed practitioner within the last year, and do not require an additional physical examination. You have 
                not altered your prescription in any way. The duty of care with respect to the prescribing of your medications is and shall remain the 
                responsibility of your physician. You will consult with your physician for any appropriate monitoring and testing. You will use your medication 
                only as directed by your physician and will remain under their care while taking your medication. 
            </p>

            <h2>Power of Attorney</h2>
            <p>
                You expressly grant to TTB (and its Partners) power of attorney to take all steps, sign all documents, and act on your behalf for the sole 
                purposes of obtaining a prescription recognized and valid within the dispensing pharmacy’s home jurisdiction, as well as packaging and 
                shipping the medications to you.
            </p>

            <h2>No Medication Returns</h2>
            <p>
                Medications cannot be returned for refund or exchange. Pursuant to Health Canada regulations and instructions, TTB cannot accept returned 
                medications.
            </p>

            <h2>Privacy Authorization</h2>
            <p>
                You have fully and accurately disclosed your personal and health information to us and authorize TTB (and its affiliated businesses and 
                partners) to collect and use your information for the fulfillment and delivery of your order.
            </p>

            <h2>Products and Services</h2>
            <p>
                TTB may revise and discontinue any products and services at any time without notice. Please call us if you have any questions about TTB’s 
                products or services.
            </p>

            <h2>Delivery</h2>
            <p>
                Delivery of the medications you order takes place when they leave the pharmacy. After delivery, TTB will, as attorney and agent for you, 
                arrange for shipment of the medications to your home address. Typically, shipments take an average of 14-21 days to arrive.
            </p>

            <h2>Warranties</h2>
            <p>
                THE MANUFACTURER OF EACH PRODUCT IS SOLELY RESPONSIBLE FOR ANY WARRANTY ASSOCIATED WITH THE PRODUCT. TO THE MAXIMUM EXTENT PERMITTED BY 
                LAW, TTB DISCLAIMS ALL WARRANTIES AND CONDITIONS, EXPRESS OR IMPLIED, IN RESPECT OF THE PRODUCTS AND SERVICES CONTEMPLATED BY THESE TERMS 
                OF SALE.
            </p>

            <h2>Severability</h2>
            <p>
                The invalidity and unenforceability of any provisions in these Terms and Conditions of Sale shall not affect the validity or enforceability 
                of any other provisions.
            </p>

            <h2>Governing Law</h2>
            <p>
                Any dispute, complaint, demand, claim, or cause of action relating to the Partner’s services will be governed by the laws of the jurisdictions 
                of the Partner pharmacy.
            </p>

            <h2>Confirmation</h2>
            <p>
                YOU SPECIFICALLY CONFIRM, ACKNOWLEDGE AND AGREE THAT EACH AND EVERY ONE OF THESE TERMS AND CONDITIONS, WITHOUT LIMITATION, WILL APPLY 
                AUTOMATICALLY AND GOVERN ANY PRESENT AND FUTURE ORDERS UNLESS YOU SPECIFICALLY INDICATE OTHERWISE AT THE TIME OF ORDERING.
            </p>

            <p>
                If at any time you have questions regarding our policies, please don’t hesitate to contact us at 
                <a href="mailto:support@toptierbenefits.com"> support@toptierbenefits.com</a>.
            </p>
        </div>
    );
};

export default TermsAndConditions;
